import {SharedModule} from '../../../shared/shared.module';
import { CategoryAssociationListComponent } from './category-association-list.component';
import {CategoryAssociationListResolver} from './category-association-list.resolver';
import {NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { DataTableModule } from 'angular-datatables-all-versions';

@NgModule({
  imports: [
    NgbModule,
    SharedModule,
    DataTableModule
  ],
  declarations: [CategoryAssociationListComponent],
  exports: [CategoryAssociationListComponent],
  providers: [CategoryAssociationListResolver]
})
export class CategoryAssociationListModule {}
